/** webapp → SDK：输入框聚焦/失焦，让宿主尽早同步键盘视口 */
export function notifyParentComposerKeyboard(open: boolean): void {
  if (window.parent === window) return;
  window.parent.postMessage(
    { channel: 'beidou-agent', type: open ? 'keyboard-focus' : 'keyboard-blur' },
    '*',
  );
}
